import type { BirdEyeOperatory, BirdEyePatient } from './types';

export type BirdEyeListLaneId = 'arriving' | 'waiting' | 'walking';

export type BirdEyeDragSource =
  | { type: 'list'; lane: BirdEyeListLaneId; patientId: string }
  | { type: 'operatory'; index: number };

export type BirdEyeDropTarget =
  | { type: 'list'; lane: BirdEyeListLaneId }
  | { type: 'operatory'; index: number };

export interface BirdEyeBoardState {
  arriving: BirdEyePatient[];
  waiting: BirdEyePatient[];
  walking: BirdEyePatient[];
  ops: BirdEyeOperatory[];
}

export interface BirdEyeBoardCounts {
  arriving: number;
  waiting: number;
  walking: number;
  seated: number;
  opTotal: number;
}

/** Day-level figures the board lanes can't derive on their own. */
export interface BirdEyeKpiExtras {
  scheduledToday: number;
  /** Mean minutes waiting across patients currently in the waiting room; `null` when nobody waits. */
  avgWaitMinutes: number | null;
}

export interface BirdEyeFinishedSummary {
  total: number;
  production: number;
  lastPatient?: string;
  lastTime?: string;
}

export const BIRD_EYE_DRAG_MIME = 'application/x-elva-bird-eye';
